import { Input, InputCmpContainer, InputContainer, InputErrorMessage, InputIcon, Label, LinearLabel } from "../styled/Input.style";

interface InputCmpProps {
    label?: string;
    value: string;
    name: any;
    setValue: Function;
    type?: string;
    className?: string;
    containerClassName?: string;
    inputIcon?: any;
    additionalElement?: any;
    labelClassName?: string;
    register?: any,
    errors?: any,
    placeholder?: string,
    companyName?: string,
    disabled?: boolean
}

const InputCmp = (props: InputCmpProps) => {
    const { value, type, setValue, name, label, placeholder, className, inputIcon,
        additionalElement, labelClassName, containerClassName
        , register, errors, companyName, disabled
    } = props

    const registerEl = register && register(name)

    // Determina il tipo di input automaticamente per i numeri di telefono
    const getInputType = () => {
        if (type) return type; // Se il tipo è specificato esplicitamente, usa quello
        if (companyName === "LINEAR" && name === 'phoneNumber') return 'tel'; // Tastiera numerica per phoneNumber
        return 'text'; // Default
    };

    return (
        <InputContainer className={`${containerClassName} ${companyName}`}>
            {companyName !== "LINEAR" && label && <Label style={{ fontWeight: 300}} className={`${labelClassName} first-capitalize`}>{label}</Label>}
            {companyName === "LINEAR" && label && <LinearLabel className={`${labelClassName} first-capitalize`}>{label}</LinearLabel>}
            <InputCmpContainer className={companyName}>
                {inputIcon && <InputIcon className={companyName}>{inputIcon}</InputIcon>}
                <Input
                    disabled={disabled}
                    {...(registerEl || {})}
                    onChange={(e) => {
                        registerEl && registerEl.onChange(e); // method from hook form register
                        setValue(e.target.value); // your method
                    }}
                    type={getInputType() || 'text'}
                    className={`${className} ${errors && errors[name] ? 'error' : ''}`}
                    value={value}
                    placeholder={placeholder}
                />
            </InputCmpContainer>
            {<InputErrorMessage className={companyName}>{errors && errors[name]?.message?.toString()}</InputErrorMessage>}
            {additionalElement}
        </InputContainer>
    )
}

export default InputCmp